module.exports = __webpack_public_path__ + "static/media/stripe-create-account_6.a47948ef.png";